export default "__VITE_ASSET__CS$6QoKT__"